import CustomModal from "../CustomModal/CustomModal";
import ReasonForm from "../CustomForms/ReasonForm";
import { REASON_MODAL_CONFIG } from "../../constants/constants";

const DANGER_MODAL_TYPES = new Set([
  "reject",
  "deactivate",
  "cancel",
  "blacklist",
]);

const ActionReasonModal = ({
  modalType,
  onClose,
  onSubmit,
  submitLoading,
  submitError,
  btnType,
  placeholder = "Write a valid reason",
  title,
  children,
}) => {
  if (!modalType) {
    return null;
  }

  const config = REASON_MODAL_CONFIG[modalType];
  const resolvedBtnType =
    btnType ?? (DANGER_MODAL_TYPES.has(modalType) ? "danger" : "primary");

  return (
    <CustomModal
      title={title ?? config?.title}
      open
      centered
      content={
        <>
          {children}
          <ReasonForm
            label={config?.label}
            placeholder={placeholder}
            btnName={config?.btnName}
            btnType={resolvedBtnType}
            submitLoading={submitLoading}
            submitError={submitError}
            onClose={onClose}
            handleOnFormSubmit={onSubmit}
          />
        </>
      }
    />
  );
};

export default ActionReasonModal;
